import React, { useMemo } from 'react';
import { useEmployeeEngagementDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/EmployeeEngagementDashboard/store/employeeEngagement.store';
import { DataTable } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/DataTable';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/EmployeeEngagementDashboard/EmployeeEngagementDashboard.styled';
import { DataTableColumn } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/FulfillmentDashboard.types';

const COLUMNS: DataTableColumn[] = [
  { key: 'teamMemberName', label: 'Team Member Name', sortable: true },
  { key: 'type', label: 'Type', sortable: true },
  { key: 'numberOfShifts', label: 'Number of Shifts', sortable: true, align: 'right' },
];

export const PickupsTable: React.FC = () => {
  const data = useEmployeeEngagementDashboardStore((s) => s.pickups);

  const rows = useMemo(
    () =>
      data?.map((d) => ({
        teamMemberName: d.teamMemberName,
        type: d.type,
        numberOfShifts: d.numberOfShifts,
      })) ?? [],
    [data],
  );

  if (!data) {
    return <EmptyStateContainer>No data available</EmptyStateContainer>;
  }

  return <DataTable columns={COLUMNS} rows={rows} ariaLabel="Pickups table" />;
};
